import Inputmask from "inputmask";

export default function addInputMask(input, mask) {
    Inputmask(mask, {
        placeholder: "_",
    }).mask(input);
}
